import React, { Component } from "react";

// Error boundary so a single failing chart/section can't blank the whole tab.
// Renders a small inline fallback instead of crashing the page. Production-grade
// safety net for third-party (Highcharts) render errors on edge-case data.
class ChartBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Keep a console trace for debugging without breaking the UI.
        console.error("ChartBoundary caught:", error, info);
    }

    componentDidUpdate(prevProps) {
        // Reset the error when the inputs change, so a transient bad-data render
        // recovers on the next (good) data instead of staying broken.
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    className="d-flex flex-column align-items-center justify-content-center text-muted"
                    style={{ minHeight: 160, fontSize: 13, border: "1px dashed #e2e8f0", borderRadius: 12, background: "#fafafa" }}
                >
                    <i className="far fa-chart-bar mb-2" style={{ fontSize: 22, color: "#cbd5e1" }} />
                    {this.props.label || "This chart couldn't be displayed for the current data."}
                </div>
            );
        }
        return this.props.children;
    }
}

export default ChartBoundary;
